import { applyBrandLocale } from "../../shared-i18n/applyBrandLocale";
import { applyBrandTheme } from "./applyBrandTheme";
import type { BrandConfig } from "./types";

/** 应用品牌主题 + 将 brand.json name 注入 i18n / document.title */
export function createInitBrandTheme(config: BrandConfig) {
  return (element?: HTMLElement): void => {
    applyBrandTheme(config, element);
    applyBrandLocale(config);
  };
}
